import React, { useEffect, useState } from "react";
import { baseRequest } from "../../axiosconfig";

function ArchiveEmployeesPage() {
  const [employees, setEmployees] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const headerTitles = [
    { id: 0, title: "Ime", width: "22%" },
    { id: 1, title: "Prezime", width: "22%" },
    { id: 2, title: "Radno mesto", width: "26%" },
    { id: 3, title: "Organizaciona jedinica", width: "22%" },
    { id: 4, title: "Datum", width: "8%" },
  ];

  useEffect(() => {
    baseRequest
      .get("/employees?archived=true")
      .then((res) => {
        setEmployees(res.data.data || []);
        setLoaded(true);
      })
      .catch(() => setLoaded(true));
  }, []);

  return (
    <div className="admin-page-child-wrapper">
      <h2
        style={{
          padding: "20px 30px 10px 30px",
          color: "var(--mainColor)",
        }}
      >
        Lista arhiviranih zaposlenih
      </h2>
      <div className="table-scroll" style={{ padding: "0 30px 30px 30px" }}>
        <ul
          className="registri-header"
          style={{
            borderLeft: "var(--mainBorder)",
            borderRight: "var(--mainBorder)",
            borderBottom: "var(--mainBorder)",
          }}
        >
          {headerTitles.map((item) => (
            <li
              key={item.id}
              className="registri-header-cell"
              style={{ width: item.width }}
            >
              {item.title}
            </li>
          ))}
        </ul>
        {loaded && employees.length === 0 && (
          <div style={{ padding: "40px", textAlign: "center", color: "var(--mainColor)" }}>
            Nema arhiviranih zaposlenih.
          </div>
        )}
        {employees.map((e) => (
          <ul
            key={e.id}
            className="registri-header"
            style={{
              borderLeft: "var(--mainBorder)",
              borderRight: "var(--mainBorder)",
              borderBottom: "var(--mainBorder)",
            }}
          >
            <li className="registri-header-cell" style={{ width: "22%" }}>{e.first_name || ""}</li>
            <li className="registri-header-cell" style={{ width: "22%" }}>{e.last_name || ""}</li>
            <li className="registri-header-cell" style={{ width: "26%" }}>{e.designation_name || ""}</li>
            <li className="registri-header-cell" style={{ width: "22%" }}>{e.organization_unit_name || ""}</li>
            <li className="registri-header-cell" style={{ width: "8%" }}>
              {e.updated_at ? e.updated_at.slice(0, 10) : ""}
            </li>
          </ul>
        ))}
      </div>
    </div>
  );
}

export default ArchiveEmployeesPage;
